<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <h1 class="title text-primary">Your code is:</h1>
  <h1 class="title text-primary">{{ getSavedCode }}</h1>
</template>

<script>
export default {
  name: "CodeScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    getSavedCode() {
      return this.$store.getters.getCode;
    },
  },
  methods: {},
};
</script>

<style lang="css" scoped>
.title {
  padding-bottom: 10px;
  font-size: 30px;
  color: #000 !important;
}
</style>
